<div class="table-responsive" *ngIf="discounts">

    <table class="custom-discounts-summary-table table table-hover table-bordered table-striped align-middle">

        <tbody>

            <tr *ngFor="let discount of discounts" class="custom-discounts-summary-table-row">
                <td class="w-75">
                    <h6 class="font-weight-bold m-0">{{ discount.description }}</h6>
                    <small class="font-weight-light">{{ discount.requirements }}</small>
                </td>
                <td class="w-25 text-center align-middle">
                    {{ getMaxDiscountCode(discount) }}
                </td>
            </tr>
        
        </tbody>

    </table>

</div>

